import React from 'react';

import Message from 'components/Message';

import AdjustsCreditsDemandIllustration from './AdjustsCreditsDemandIllustration';
import messages from './AdjustsCreditsPanel.messages';
import SmartRateTopicPanelLayout from './SmartRateTopicPanelLayout';

const AdjustsCreditsPanel = () => (
  <SmartRateTopicPanelLayout
    summaryBody={
      <>
        <Message as="p" message={messages.summaryBodyParagraph1} />
        <Message as="p" message={messages.summaryBodyParagraph2} />
      </>
    }
    summaryHeading={messages.summaryHeading}>
    <AdjustsCreditsDemandIllustration />
  </SmartRateTopicPanelLayout>
);

export default AdjustsCreditsPanel;
